module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/logo_leaders01-957d7988df30c3ddc3c65bac7733972b.svg";